import { instance } from "../apiclient";
import { CreateOrderObject, CreateGiftOrderObject } from "./Utilities";
import store from "../../store/index";
import uuid from "uuid/v1";
import { getCurrency } from "../helpers/storeHelper";
// import { DateTime } from "luxon";

export class DefaultPaymentHandler {
  async MakePayment(
    guid,
    card,
    user,
    resturant,
    orderInfo,
    guestUserId,
    paymentMethod,
    isGift = false,
    AppliedCouponList = [],
    loyalty = { RedeemPoints: 0, RewardPoints: 0 },
    stripe,
    cardElement,
    customerID = "",
    isSavedCard = false,
    twoStepPayment = false,
    stripeToken = null,
  ) {
    const res = {
      data: {
        Success: false,
        customerID: trackingOrderModel
          && trackingOrderModel.TrackingOrder
          && trackingOrderModel.TrackingOrder.OnlineOrderUserIdentifier
          ? trackingOrderModel.TrackingOrder.OnlineOrderUserIdentifier : "",
        Status: {
          Message: '',
        } 
      }
    }
    var trackingOrderModel = this.MakePaymentBody(
      guid,
      card,
      user,
      resturant,
      orderInfo,
      guestUserId,
      paymentMethod,
      isGift,
      AppliedCouponList,
      loyalty,
      twoStepPayment,
      stripeToken
    );
    store.commit("addUserOrderHistory", trackingOrderModel.TrackingOrder);
    let result = {
      success: false,
      error: '',
    }
    if (trackingOrderModel.TrackingOrder.IsPayLater) {
      result = await handlePayLater(trackingOrderModel, guid);
    } else {
      const currency = getCurrency("");
      const paymentMethod = isSavedCard ? trackingOrderModel.TrackingOrder.PaymentCardIdentifier : "";
      result = await handleCardPayment(trackingOrderModel, guid, currency, stripe, cardElement, customerID, paymentMethod);
    }
    if (!result.success) res.data.Status.Message = result.error;
    else {
      res.data.Success = true;
    }
    return res;
  }

  MakePaymentBody(
    guid,
    card,
    user,
    resturant,
    orderInfo,
    guestUserId,
    paymentMethod,
    isGift = false,
    AppliedCouponList = [],
    loyalty = { RedeemPoints: 0, RewardPoints: 0 },
    twoStepPayment = false,
    stripeToken = null
  ) {
    var orderModel;
    if (isGift) {
      var surchareItem = {
        totalPrice: store.getters.giftTotalPrice,
        subTotalPrice: store.getters.giftCartValue,
        bankCardSurcharge: store.getters.getGiftcardSurchargeBankAmount,
        pOSSurchargeTax: store.getters.getGiftSurchargeHolidayValidTax,
        pOSSurchargeExcludingTax: 0,
        surchargeTransactions: store.getters.getSurchargeHolidayValid,
      };
      orderModel = CreateGiftOrderObject(
        store.state.giftShoppingCart,
        surchareItem,
        user,
        resturant,
        card,
        guid,
        orderInfo,
        AppliedCouponList
      );
    } else {
      let priceItem = {
        totalPrice: store.getters.getTotalPrice,
        subTotalPrice: store.getters.cartValue,
        totalTax: store.getters.totaltax,
        freeOrderItems: store.getters.getFreeOrderItems,
        discountTax: store.getters.discountTax,
        discountExcludingTax: store.getters.discountExcludingTax,
        bankCardSurcharge: store.getters.getSurchargeBankAmount(),
        pOSSurchargeTax: store.getters.getSurchargeHolidayValidTax,
        pOSSurchargeExcludingTax: store.getters.getSurchargeHolidayAmount,
        surchargeTransactions: store.getters.getSurchargeTransactions,
      };
      orderModel = CreateOrderObject(
        store.getters.cartItems.filter((p) => !p.disable),
        store.getters.deliveryFee,
        priceItem,
        user,
        resturant,
        card,
        guid,
        orderInfo,
        guestUserId,
        store.getters.priceTriggerOutcomes,
        AppliedCouponList
      );
      orderModel.payment;
    }
    SetPaymentMethodType(orderModel, paymentMethod, stripeToken);
    if (twoStepPayment) {
      orderModel.PaymentGateway = 6;
    }
    const trackingOrderModel = {
      TrackingOrder: {
        Source: "Online Order",
        ...orderModel,
        AppliedCouponCodes: !AppliedCouponList
          ? null
          : AppliedCouponList.map((c) => {
              return c.coupon.CouponCode;
            }),
        RoomNumber: orderInfo.roomNumber,
        ...loyalty,
      },
    };
    if (orderInfo.tableNumber) {
      Object.defineProperty(trackingOrderModel.TrackingOrder, "Tables", {
        value: [
          { Name: orderInfo.tableNumber, SecurityCode: orderInfo.securityCode },
        ],
        enumerable: true,
      });
    }

    if (orderInfo.isPayLater) {
      trackingOrderModel.TrackingOrder.IsPayLater = true;
    }
    
    if (user.IsGuest) {
      const userObject = {
        FirstName: user.FirstName,
        LastName: user.LastName,
        Email: user.Email,
        CreateUserForGuest: user.CreateUserForGuest,
      };
      if(typeof user.DineInField != 'undefined') {
        userObject.DineInField = user.DineInField;
      }
      Object.defineProperty(trackingOrderModel, "GuestUser", {
        value: userObject,
        enumerable: true,
      });
    }
    return trackingOrderModel;
  }

  Reorder(orderItem) {
    var order = Object.assign({}, orderItem);
    var guid = uuid();
    order.OnlineOrderStatus = 1;
    order.CreatedOn = new Date().toUTCString();
    order.InvoiceNumber = "";
    order.OnlineOrderStatusDescription = "";
    order.PaymentTransactions = [
      {
        Amount: order.PaymentTransactions[0].Amount,
      },
    ];
    order.ScheduledTime = new Date().toUTCString();
    delete order.IsTimeOut;
    for (var tempItem of order.OrderItems) {
      tempItem.CreatedOn = new Date().toUTCString();
      tempItem.UDID = uuid();
      for (var tempExtra of tempItem.OrderExtras) {
        tempExtra.UDID = uuid();
      }
    }
    order.UDID = guid;
    const trackingOrderModel = {
      TrackingOrder: {
        ...order,
      },
    };
    return instance.post("trackingorders/" + guid, trackingOrderModel);
  }

  PreparePaymentUrl(orderDetails) {
    var data = {
      PaymentType: orderDetails.PaymentType,
      StoreId: orderDetails.storeId,
      OrderId: orderDetails.orderId,
      UserId: orderDetails.userId,
      AppName: "Online Ordering",
      TotalAmount: orderDetails.totalAmount,
      ReturnUrl: document.location.href,
      IsMobile: orderDetails.isMobile,
    };

    return instance.post("supaypayment/supaypaymentstart", data);
  }
}

function SetPaymentMethodType(orderModel, paymentMethod, stripeToken) {
  switch (paymentMethod) {
    case 1: //Card
      orderModel.PaymentTransactions[0].PaymentMethodType = 99; //AbacusPayment
      break;
    case 2:
      orderModel.PaymentTransactions[0].PaymentMethodType = 10; //LoyaltyPointRedemption
      break;
    case 3:
      orderModel.PaymentTransactions[0].PaymentMethodType = 1; //Cash
      break;
    case 4:
      orderModel.PaymentTransactions[0].PaymentMethodType = 12; //AliPay
      break;
    case 5:
      orderModel.PaymentTransactions[0].PaymentMethodType = 13; //WeChat
      break;
    case 6:
      orderModel.PaymentTransactions[0].PaymentMethodType = 15; //Apple Pay
      orderModel.PaymentTransactions[0].RenfrenceNumber = stripeToken; //Apple Pay
      break;
    case 7:
      orderModel.PaymentTransactions[0].PaymentMethodType = 14; //Google Pay
      orderModel.PaymentTransactions[0].RenfrenceNumber = stripeToken; //Google Pay
      break;
    case 8:
      orderModel.PaymentTransactions[0].PaymentMethodType = null; //Pay Later
      break;
  }
}

const createPaymentIntent = async (
  storeId,
  amount,
  currency,
  customerID = "",
  paymentMethod = "",
  email = "",
  name = "",
  orderId = "",
) => {
  const payload = {
    currency: currency,
    Amount: Math.round(amount * 100),
    paymentID: paymentMethod,
    customerID: customerID,
    email,
    name,
    orderId,
  };
  let status = false;
  let error = "";
  let data = {};
  try {
    const response = await instance.post(
      `/stripepayment/${storeId}/paymentintent`,
      JSON.stringify(payload)
    );
    data = response.data;
    // response from cloud function should be success. otherwise return error message.
    if (response.status === 200 && data.Success) {
      status = true;
    } else {
      error = data.Status && data.Status.Message ? data.Status.Message : "Internal Error Occurred";
    }
  } catch (ex) {
    error = ex;
    status = false;
  }
  return { status, error, data };
};

const confirmPaymentIntent = async (
  client_secret,
  paymentMethodId,
  stripe,
  card
) => {
  let result;
  try {
    if (paymentMethodId) {
      result = await stripe.confirmCardPayment(client_secret);
    } else {
      result = await stripe.confirmCardPayment(
        client_secret,
        { payment_method: { card: card } }
      );
    }
    if (result.error) {
      // in case payment is already confirmed, send success response
      if (
        result.error.code === "payment_intent_unexpected_state" &&
        result.error.payment_intent && result.error.payment_intent.status === "succeeded"
      ) {
        return { status: true, error: "" };
      }

      switch (result.error.type) {
        case "api_connection_error":
          throw new Error("Please check your internet connection. Please contact store before attempting a new payment.");
        default:
          throw new Error(result.error.message || "Something went wrong! Please try again");
      }
    }

    if (result.paymentIntent.status !== "succeeded") throw new Error("Please complete the payment.");

    return { status: true, error: "" };
  } catch (ex) {
    const error = ex.message || "An error occurred. Please try again later.";
    return { status: false, error };
  }
};

export const createOrder = async (orderId, trackingOrder) => {
  try {
    const response = await instance.post(
      `/trackingorders/${orderId}/createorder`,
      JSON.stringify(trackingOrder)
    );

    // response from cloud function should be success. otherwise return error message.
    if (response.status === 200 && response.data.Success) {
      return {
        status: true,
        error: '',
      };
    }

    // check if error message tag is `EXISTING_ORDER_IN_PROGRESS` if yes then return success
    if (response.data && response.data.Status && response.data.Status.Tag === "EXISTING_ORDER_IN_PROGRESS") {
      return {
        status: true,
        error: '',
      };
    }

    throw new Error(
      response.data && response.data.Status && response.data.Status.Message
      ? response.data.Status.Message
      : "Internal Error Occurred"
    );
  } catch (ex) {
    const error = ex && ex.message ? ex.message : "Something went wrong! Please try again";
    return { status: false, error };
  }
}

export const moveOrder = async (orderId, storeID) => {
  let status = false;
  let error = "";
  let data = {};
  try {
    const response = await instance.post(
      `/trackingorders/${orderId}/moveorder`,
      JSON.stringify({ storeID })
    );

    // response from cloud function should be success. otherwise return error message.
    if (response.status === 200 && response.data.Success) {
      status = true;
      data = response.data;
    } else {
      error = response.data && response.data.Status && response.data.Status.Message ? response.data.Status.Message : "Internal Error Occurred";
    }
  } catch (ex) {
    error = ex;
    status = false;
  }
  return { status, error, data };
}

const handleCardPayment = async (
  trackingOrderModel,
  orderId,
  currency,
  stripe,
  cardElement,
  customerID = "",
  paymentMethod = ""
) => {
  try {
    const storeId = trackingOrderModel && trackingOrderModel.TrackingOrder ? trackingOrderModel.TrackingOrder.StoreID : "";
    const updatedTrackingOrderModel = { ...trackingOrderModel }
    const trackingOrder = updatedTrackingOrderModel.TrackingOrder;
    const totalAmount = parseFloat(
      (trackingOrder.TotalExcludingTax + trackingOrder.TotalTax).toFixed(2)
    );
    let email = "";
    if (trackingOrderModel.GuestUser) {
      email = trackingOrderModel.GuestUser.Email || "";
    } else if (trackingOrderModel.TrackingOrder.ContactCustomer_Email_Address) {
      email = trackingOrderModel.TrackingOrder.ContactCustomer_Email_Address;
    }
    const name = trackingOrder.ContactCustomer_DisplayName || trackingOrder.ContactCustomer_FirstName || "";

    if (totalAmount < 0) return { success: false, error: "Invalid Amount" };
    if (totalAmount === 0) return await handlePayLater(updatedTrackingOrderModel, orderId);

    const createIntent = await createPaymentIntent(storeId, totalAmount, currency, customerID, paymentMethod, email, name, orderId);
    if (createIntent.error) return { success: false, error: createIntent.error };
    delete updatedTrackingOrderModel.Card;
    const clientSecret = createIntent.data.ClientSecret;
    const paymentIntent = createIntent.data.PaymentIntent;
    if (trackingOrder.PaymentTransactions.length) {
      updatedTrackingOrderModel.TrackingOrder.PaymentTransactions[0].ReferenceNumber = paymentIntent;
    }
    updatedTrackingOrderModel.TrackingOrder.PaymentGateway = 8; // Payment Gateway
    updatedTrackingOrderModel.TrackingOrder.SkipStrategy = true // to skip strategy logic in CF
    const order = await createOrder(orderId, updatedTrackingOrderModel);
    if (order.error) return { success: false, error: order.error };
    const confirm = await confirmPaymentIntent(clientSecret, paymentMethod, stripe, cardElement);
    if (confirm.error) {
      await deleteTempOrder(storeId, orderId);
      return { success: false, error: confirm.error };
    }
    return {
      success: true,
      error: '',
    };
  } catch (error) {
    return {
      success: false,
      error,
    };
  }
}

const handlePayLater = async (
  trackingOrderModel,
  orderId,
) => {
  try {
    const updatedTrackingOrderModel = { ...trackingOrderModel }
    updatedTrackingOrderModel.TrackingOrder.SkipStrategy = true // to skip strategy logic in CF
    const order = await createOrder(orderId, updatedTrackingOrderModel);
    if (order.error) return { success: false, error: order.error };
    return {
      success: true,
      error: '',
    };
  } catch (error) {
    console.log('error', error)
    return {
      success: false,
      error,
    };
  }
}

export const createPaymentMethod = async (card, stripe, email, name) => {
  let paymentMethodID = "";
  let error = "";
  let cardDetails;

  const result = await stripe.createPaymentMethod({
    type: 'card',
    card,
    billing_details: {
      email: email,
      name: name,
    }
  });

  if (result.error) {
    error = result.error.message || "Something went wrong! Please try again";
  } else {
    if (result.paymentMethod && result.paymentMethod.card) {
      paymentMethodID = result.paymentMethod.id;
      cardDetails = result.paymentMethod.card;
    }
  }

  return { paymentMethodID, ex: error, card: cardDetails };
};

export const createCustomer = async (email, paymentMethodID, customerID, storeID) => {
  let createdID = '';

  try {
    const result = await instance.post(
      '/stripepayment/createcustomer',
      JSON.stringify({ email: email, paymentMethodID: paymentMethodID, customerID: customerID, storeID: storeID })
    );

    if (result.data && result.data.Success) {
      createdID = result.data.id;
    }
  } catch (error) {
    createdID = '';
  }

  return createdID;
};

export const getCards = async (customerID, storeID) => {
  let cards = [];
  let status = false;
  let error = "";

  try {
    const result = await instance.post(
      `/stripepayment/customer/${customerID}`,
      JSON.stringify({ storeID })
    );

    if (result.data && result.data.Success) {
      status = true;
      cards = result.data.Data;
    }
  } catch (ex) {
    error = ex;
  }

  return {
    cards: cards,
    error: error,
    status: status,
  };
};

export const handleDeleteCard = async (paymentMethodID, storeID) => {
  let success = false;
  let error = '';
  try {
    const result = await instance.delete(
      '/stripepayment/delete-payment-method',
      { data: { paymentMethodID: paymentMethodID, storeID: storeID }}
    );

    if (result.data && result.data.Success) {
      success = true;
    } else {
      error = result.data.Status.Message;
    }
  } catch (ex) {
    error = "something went wrong"
  }

  return { success, error };
};

export const deleteTempOrder = async (storeID, orderID) => {
  try {
    await instance.delete(
      `/trackingorders/${orderID}/deleteorder/${storeID}`,
    );
  } catch (error) {
    console.error('deleteOrder -> error', error);
  }
}
